// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"531":"d16d1495","810":"8dcac2a8","928":"3b3e6a44"}[chunkId] + ".chunk.js";
};